export const localStore = (): Storage => {
  return window.sessionStorage;
};
